import { defineComponent as _defineComponent } from 'vue'
import { withDefaults } from 'vue';
  import BaseText from '@ui/atoms/baseText/BaseText.vue';
  import { Options } from '../pulse/types';

  
  const __default__ = {
    name: 'LabelledSelect',
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    options: { type: Array, required: false },
    labelColor: { type: String, required: true, default: '#000' },
    value: { type: [String, Number, null], required: false },
    label: { type: String, required: true, default: 'Select' },
    name: { type: String, required: true },
    backgroundColor: { type: String, required: true, default: '#f8f8f8' },
    labelOpacity: { type: String, required: true, default: '1' }
  },
  emits: ["change"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'change', value: string | number | null): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { options?: Array<Options>, labelColor: string, value?: string | number | null, label: string, name: string, backgroundColor: string, labelOpacity: string };

  

  

  function handleChange(e: Event) {
    emits('change', (e.target as HTMLSelectElement).value);
  }

return { __sfc: true,emits, props, handleChange, BaseText }
}

})